<template>
  <div :class="['contact-info', { 'in-footer': inFooter }]" ref="container">
    <h2 class="section-title" v-if="!inFooter">Get in Touch</h2>

    <div class="info-card factory-panel">
      <!-- 工厂信息 -->
      <h3 class="panel-title" v-if="!inFooter">Our Companies</h3>
      <div class="factory-blocks">
        <div class="factory-block">
          <div class="factory-header">
            <Icon fontName="factory" class="factory-icon" />
            <div>
              <h4 class="factory-name">SHIXIAO MACHINERY</h4>
              <p class="factory-type">Abrasive Machinery Manufacturing Facility</p>
            </div>
          </div>
          <p class="factory-address">
            Huadichong Community<br />
            Baizhai Town<br />
            Xinmi, Henan, China
          </p>
        </div>


          <!-- 销售中心 -->
          <div class="factory-block">
            <div class="factory-header">
              <Icon fontName="factory" class="factory-icon" />
              <div>
                <h4 class="factory-name">YOLEE TECHNOLOGY</h4>
                <p class="factory-type">Act as the professional service and sales organization for SHIXIAO Machinery (ABR®  )</p>
              </div>
            </div>
            <p class="factory-address">
              No. 133 Yaozhai Road<br />
              Jinshui District<br />
              Zhengzhou, 450000, China
            </p>
          </div>
      </div>

      <!-- 电话和邮箱 -->
      <div class="info-contact">
        <div class="info-item">
          <Icon fontName="tel" class="icon-container" />
          <div>
            <h3>Direct Line</h3>
            <p>
              +86 158-0399-0204<br />
              Mon – Fri, 9:00 AM – 5:00 PM<br />
              China Standard Time (UTC+8)
            </p>
          </div>
        </div>

        <div class="info-item">
          <Icon fontName="email" class="icon-container" />
          <div>
            <h3>General Inquiries</h3>
            <p>
              info@yoleecorp.com<br />
              Typical response within 24 hours
            </p>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import Icon from "@/components/Icon";

export default {
  name: "ContactInfo",
  components: { Icon },
  props: { inFooter: { type: Boolean, default: false } },
};
</script>

<style lang="less" scoped>
@import "~@/assets/styles/variables.less";
@import "~@/assets/styles/mixins.less";

.contact-info {
  .info-card.factory-panel {
    background: #f3f4f5;
    border-radius: 14px;
    padding: 2rem;
  }

  .panel-title {
    margin-bottom: 1rem; // ✅ 增加顶部标题和工厂块间距
    font: 700 18px / 1.3 "Roboto", system-ui, sans-serif;
    color: #3a5f49;
  }

  .factory-blocks {
    display: flex;
    flex-wrap: wrap;
    gap: 1.5rem;
  }

  .factory-block {
    background: white;
    padding: 1.5rem 1.2rem;
    border-radius: 10px;
    flex: 1 1 250px;
    max-width: 400px;
    border-left: 6px solid fade(@color-primary, 60%);
  }

  .factory-header {
    display: flex;
    align-items: center;
    gap: 1rem;
  }

  .factory-icon {
    font-size: 2.2rem;
    color: @color-primary;
  }

  .factory-name {
    font: 700 18px/1.3 @font-en;
  }

  .factory-type {
    font-size: 14px;
    color: @color-primary;
  }

  .factory-address {
    margin-top: 0.8rem;
    line-height: 1.6;
  }

  /* 电话和邮箱信息响应式布局 */
  .info-contact {
    display: flex;
    flex-wrap: wrap;
    gap: 3rem; // ✅ 并排或上下显示间距统一设置
    margin-top: 1rem; // ✅ 与工厂块间距略小

    .info-item {
      display: flex;
      gap: 0.8rem; // ✅ icon 与文字间距
      flex: 0 1 auto;
      align-items: flex-start;

      .icon-container {
        font-size: 2rem;
        color: @color-primary;
        flex-shrink: 0;
      }

      h3 {
        font: 600 18px/1.3 @font-en;
        margin-bottom: 0.2rem; // ✅ 顶部标题和内容间距略小
        color: @color-primary;
      }

      p {
        line-height: 1.5; // ✅ 略紧凑
      }
    }
  }

  /* Footer 特化样式 */
  &.in-footer {
    .info-card.factory-panel {
      background: transparent;
      padding: 0;
      box-shadow: none;
    }

    .factory-block {
      border-left: 4px solid fade(@color-primary, 60%);
      flex: 1 1 200px;
      max-width: none;
    }
  }
}

/* 移动端强制上下排列 */
@media screen and (max-width: 768px) {
  .info-contact {
    margin-top: 2rem !important;
    flex-direction: column;
    gap: 1rem !important; // ✅ 上下排列间距
  }
}
</style>
